module.exports = __webpack_public_path__ + "img/bottom-left-corner.525ca1df.svg";